<!--
  Uncomment and customize cell renderers if needed.
  Requires app-correlation-dashboard-table [cellRendererTmplRef]="correlationDashboardCellRendererTmpl"
  See volunteer-task-table for detailed example
-->
<!--
<ng-template
  #correlationDashboardCellRendererTmpl
  let-record="record"
  let-column="column"
  let-showRequestFn="showRequestFn"
  let-tableComponent="tableComponent"
>
  <ng-container [ngSwitch]="column.template">
    <td
      fes-table-view-default-cell-renderer
      *ngSwitchDefault
      [column]="column"
      [record]="record"
      [tableComponent]="tableComponent"
    ></td>
  </ng-container>
</ng-template>
-->


<app-correlation-dashboard-table
  [tabConfig]="tabConfig"
  [detailFn]="detailFn"
  [isActiveView]="tabConfig.active"
  [contextJson]="tabConfig.viewInfo.id"
  (contextJsonChange)="contextJsonChangeHandler($event, tabConfig)"
  (recordsLoaded)="onTableLoaded($event)"
  #dashboardTable
>
  <button
    footerButtonRow
    class="btn btn-secondary btn-sm mx-2"
    (click)="dashboardTable.rebuildAll()"
    [disabled]="dashboardTable.bRebuilding"
    title="Rebuild entire dashboard for all buildings and stages"
  >
    <i
      class="fa mr-1"
      [ngClass]="
        dashboardTable.bRebuilding ? 'fa-spinner fa-spin' : 'fa-hammer'
      "
    ></i>
    Rebuild
  </button>

  <ng-container afterDownloadButton>
    <select
      #selectParticipant
      class="my-auto mx-2 px-sm-1"
      name="participant-select"
      (change)="changeParticipant(selectParticipant.value)"
    >
      <option value="">-- Participant --</option>
      <option *ngFor="let participant of distinctParticipants" [ngValue]="participant">{{participant}}</option>
    </select>
    <select
      *ngIf="selectedParticipant"
      #selectStage
      class="my-auto mr-2 px-sm-1"
      name="stage-select"
      (change)="changeParticipantStage(selectStage.value)"
      required
    >
      <option value="">-- Stage --</option>
      <option *ngFor="let stage of participantStages" [ngValue]="stage">{{stage}}</option>
    </select>
    <div class="my-auto">
    <button
      [disabled]="!selectedParticipantStage || downloadRollupSummLoading"
      class="btn btn-info btn-sm mr-1" title="Download Rollup-Summary"
      (click)="rollupSummaryReportXLWbk()">
      <i class="fa fa-file-export p-0 m-0 mr-1" [ngClass]="{blink:downloadRollupSummLoading}"></i>
      Rollup Summary
    </button>
    </div>
  </ng-container>
  <div *ngIf="dashboardTable?.correlatingJobs.length"
      class="text-secondary small font-italic mx-2 d-flex flex-row align-items-center">
    {{dashboardTable?.correlatingJobs.length}} active correlation job(s)
  </div>

</app-correlation-dashboard-table>
